/* eslint-disable */
// This enum contains the types of generate Shipments associated with the right restEndpoint.
export enum GenerateShipmentsEntitiesEnum {
  GENERATE = 'generateShipments',
  DROP_GENERATE = 'dropGenerateShipments',
  DROP_ONLY_CANCELABLE = 'dropOnlyCancelable',
  GENERATE_MISSING = 'generateMissingShipments',
}
